import { Injectable } from '@angular/core';
import {protectedResources} from "../../auth-config";
import { HttpClient } from "@angular/common/http";
import {Observable, of, tap} from "rxjs";
import {Tenant} from "../../shared/models/tenant.model";
import {catchError} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class InternalOnboardService {
  brennerSoftwareApiEndpoint: string = protectedResources.BrennerSoftwareApi.endpoint;

  constructor(
    private http: HttpClient
  ) {}

  get(): Observable<any> {
    return this.http.get<any>(this.brennerSoftwareApiEndpoint + `internalOnboard/getList/`);
  }

  createTenant(tenant: Tenant){
    return this.http.post<any>(this.brennerSoftwareApiEndpoint + `internalOnboard/create/`, tenant);
  }

  createDefaultRoles(tenant: Tenant){
    return this.http.post<any>(this.brennerSoftwareApiEndpoint + `internalOnboard/createDefaultRoles/`, tenant);
  }

  createBlobContainer(tenant: Tenant){
    return this.http.post<any>(this.brennerSoftwareApiEndpoint + `internalOnboard/createBlobContainer/${tenant.tenantId}`, {});
  }
}
